import React, {Component} from 'react';
import KierowcaLogiTable from "./components/KierowcaLogiTable";
import LogiService from "../LogiService";
import EplatnosciTable from "../../../konfiguracja/biletyConfig/eplatnosci/components/EplatnosciTable";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {Col} from "react-bootstrap";


export default class KierowcaLogiTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logi:[],
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            trwaSzukanie: false,
        };
        this.onSizePerPageList=this.onSizePerPageList.bind(this)
        this.onPageChange=this.onPageChange.bind(this)
    }

    componentDidMount() {
        this.pobierzLogi(1,15)
    }

    pobierzLogi(strona=this.state.strona, ilosc=this.state.ilosc){
        this.setState({trwaSzukanie: true})
        LogiService.getLogiEbusDriver(strona-1,ilosc).then(function (response) {
            this.setState({
                logi:response.data.content,
                pageable: {
                    first: response.data.first,
                    last: response.data.last,
                    page: response.data.number,
                    size: response.data.size,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                },
                trwaSzukanie: false
            })
        }.bind(this)).catch(function (err) {
            this.setState({trwaSzukanie: false})
        }.bind(this))
    }

    onSizePerPageList(size) {
        this.setState({ilosc: size})
    }

    onPageChange(page, sizePerPage) {
        this.setState({strona: page})
        this.pobierzLogi(page, sizePerPage)
    }

    render() {

        return (
            <div>
                <Col xs={12}>
                    <TopIf isTrue={this.state.trwaSzukanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa szukanie rekordów...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                </Col>
                <KierowcaLogiTable data={this.state.logi}
                                   pageable={this.state.pageable}
                                   ilosc={this.state.ilosc}
                                   strona={this.state.strona}
                                   onSizePerPageList={this.onSizePerPageList}
                                   onPageChange={this.onPageChange}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/logi/kierowcyTab/KierowcaLogiTab.js